import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://ayodhyadham.info';

/**
 * Breadcrumbs — items: [{ label, to? }]; the last item renders as plain text.
 *
 * Also emits the matching BreadcrumbList structured data, so any page that
 * shows a trail gets it without repeating the schema by hand. PageHero renders
 * this component, so pages using PageHero are covered too.
 */
export default function Breadcrumbs({ items = [], className = '', schema = true }) {
  if (!items.length) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: it.to.startsWith('http') ? it.to : `${SITE_URL}${it.to}` } : {}),
    })),
  };

  return (
    <>
      {schema && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Helmet>
      )}
      <nav className={`crumbs${className ? ` ${className}` : ''}`} aria-label="Breadcrumb">
        <ol>
          {items.map((it, i) => {
            const last = i === items.length - 1;
            return (
              <li key={`${it.label}-${i}`} aria-current={last ? 'page' : undefined}>
                {it.to && !last ? <Link to={it.to}>{it.label}</Link> : <span>{it.label}</span>}
                {!last && <span className="crumbs__sep" aria-hidden="true">›</span>}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}
